import { render, staticRenderFns } from "./InstrumentareaFields.vue?vue&type=template&id=006091f2"
import script from "./InstrumentareaFields.vue?vue&type=script&lang=js"
export * from "./InstrumentareaFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports